<template>
  <md-field md-clearable @md-clear="clearValue" class="md-invalid date-time">
    <div class="w-full relative cursor-pointer">
      <div class="w-full h-full flex">
        <label>{{ $t(label) }}</label>
        <md-input
          :disabled="disabled"
          v-model="dateTimePicker"
          :required="required"
          readonly
        ></md-input>
        <slot></slot>
      </div>
      <date-picker
        :disabled="disabled"
        :disabled-date="disabledDate"
        v-model="dateTimePicker"
        type="datetime"
        :format="formatDateClient"
        value-type="format"
        @change="changeValue($event)"
        class="date-time-picker"
        ref="dateTimePicker"
      ></date-picker>
    </div>
  </md-field>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  convertDateFromServer,
  convertDateSendServer
} from "@/helpers/datetime-helper";

export default {
  name: "date-time-picker",
  components: { DatePicker },
  props: {
    label: String,
    required: {
      type: Boolean,
      default: false
    },
    value: String,
    disabled: {
      type: Boolean,
      default: false
    },
    disabledDate: {
      type: Function,
      default: () => {}
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  data() {
    return {
      formatDateClient:
        localStorage.getItem("language") === "en"
          ? "MM-DD-YYYY HH:mm"
          : "DD-MM-YYYY HH:mm"
    };
  },
  computed: {
    dateTimePicker: {
      get: function() {
        return convertDateFromServer(this.value, "date-time");
      },
      set: function(value) {
        return value;
      }
    }
  },
  methods: {
    changeValue(newValue) {
      if (newValue) {
        const dateSendServer = convertDateSendServer(newValue, "date-time");
        this.$emit("change", dateSendServer);
      } else {
        this.clearValue();
      }
    },
    clearValue() {
      this.dateTimePicker = "";
      this.$emit("change", "");
    }
  }
};
</script>
<style lang="scss">
.date-time {
  &-picker {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100% !important;

    input.mx-input {
      background: transparent;
      border: 0;
      box-shadow: none;
      color: transparent;
      cursor: pointer;
    }
    .mx-icon-clear {
      color: transparent;
    }
  }

  .md-error {
    top: 35px;
  }

  button[disabled="disabled"].md-clear {
    display: none;
  }
}
</style>
